import Vue from 'vue'
import Router from 'vue-router'
import Main from './views/Main.vue'
import store from './store'
import Cookies from 'js-cookie'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Main,
      beforeEnter: authCheck,
      children: [
        {
          path: '/MainTab',
          name: 'MainTab',
          component: () => import('@games/MainTab.vue'),
          meta: {title: 'MainTab'}
        },
        {
          path: '/MatchDetails',
          name: 'MatchDetails',
          component: () => import('@games/MatchDetails.vue'),
          meta: {title: 'MatchDetails'},
          props: {data: null},
        },
        {
          path: '/OverUnder',
          name: 'OverUnder',
          component: () => import('@games/OverUnder.vue'),
          meta: {title: 'OverUnder'}
        },
        {
          path: '/HomeOVUN',
          name: 'HomeOVUN',
          component: () => import('@games/HomeOVUN.vue'),
          meta: {title: 'HomeOVUN'}
        },
        {
          path: '/AwayOVUN',
          name: 'AwayOVUN',
          component: () => import('@games/AwayOVUN.vue'),
          meta: {title: 'AwayOVUN'}
        },
        {
          path: '/1X2OVUN1',
          name: '1X2OVUN1',
          component: () => import('@games/1X2OVUN1.vue'),
          meta: {title: '1X2OVUN1'}
        },
        {
          path: '/1X2OVUN2',
          name: '1X2OVUN2',
          component: () => import('@games/1X2OVUN2.vue'),
          meta: {title: '1X2OVUN2'}
        }
      ]
    },
    {
      path: '/auth',
      name: 'auth',
      component: () => import('./views/Auth.vue'),
      meta: {title: 'Login Page'}
    },
    {
      path: '*',
      redirect: {name: 'NotFound'}
    },
    {
     path: '/report',
      name: 'report',
      beforeEnter: authCheck,
      component: () => import('./views/Report.vue'),
      meta: {title: 'Report'} 
    },
    {
     path: '/statistics',
      name: 'statistics',
      beforeEnter: authCheck,
      component: () => import('./views/Statistics.vue'),
      meta: {title: 'statistics'} 
    },
    {
     path: '/ticket',
      name: 'ticket',
      component: () => import('./views/Ticket.vue'),
      meta: {title: 'statistics'} 
    },
    {
     path: '/TV/:lang/:Token',
      name: 'TV',
      component: () => import('./views/TV.vue'),
      meta: {title: 'TV'},
      props: true,
    },
    {
     path: '/TV2/:lang/:Token',
      name: 'TV2',
      component: () => import('./views/TV2.vue'),
      meta: {title: 'TV2'} 
    },
    {
     path: '/TV3/:lang/:Token',
      name: 'TV3',
      component: () => import('./views/TV3.vue'),
      meta: {title: 'TV3'} 
    },
    {
     path: '/TV4/:lang/:Token',
      name: 'TV4',
      component: () => import('./views/TV4.vue'),
      meta: {title: 'TV4'} 
    },
    {
     path: '/TV5/:lang/:Token',
      name: 'TV5',
      component: () => import('./views/TV5.vue'),
      meta: {title: 'TV5'} 
    },
    {
     path: '/TV6/:lang/:Token',
      name: 'TV6',
      component: () => import('./views/TV6.vue'),
      meta: {title: 'TV6'} 
    },
    {
     path: '/TV7/:lang/:Token',
      name: 'TV7',
      component: () => import('./views/TV7.vue'),
      meta: {title: 'TV7'} 
    },
    {
     path: '/jackpot/:lang/:Token',
      name: 'Jackpot',
      component: () => import('./views/Jackpot.vue'),
      props: {token: null, amount: null},
      meta: {title: 'jackpot'} 
    },
    {
     path: '/countdown/:lang/:Token',
      name: 'countdown',
      component: () => import('./views/countdown.vue'),
      meta: {title: 'countdown'} 
    }
  ]
})

function authCheck(to, from, next){  //check if not authorised and redirect to login if so
  let user = { user: Cookies.get('username'),
  pw: Cookies.get('password')};
  if(user.user && !store.state.authenticated){
    store.dispatch('login', user).then((response)=>{
      store.dispatch('apirequest', {token: response.data.token, name: "game/kass"}).then((responses) => {
            store.state.Time = (store.state.game.Time - Date.now()) / 1000;
          });
      store.dispatch('apirequest', {token: response.data.token, name: "teams/"});
      store.dispatch('apirequest', {token: response.data.token, name: "jackpot/"+response.data.id});
      if(to.name == 'home'){
        next({name: 'MainTab'})
      }else{
        next()
      }
    })
  }
  if(user.user){
    store.dispatch('login', user).then(()=>{ 
      next()
    }).catch(()=>{
      next({name: 'auth'})
    });
  }
  else if(store.state.authenticated){
    next()
  }
  else next({name: 'auth'});
}

router.beforeEach((to, from, next) => {
  if(!to.meta.title) document.title = 'pg-title-default';
  else document.title = to.meta.title;
  next();
});

export default router;